import {BaseContainerModel} from "../../../base-container.model";
import {
    bl_alg_cc_rule_action_ext_RowClass, 
    bl_alg_cc_rule_action_hdr_RowClass, 
    bl_alg_cc_rule_action_hdr_RowInterface

}from "../../../../dbschema"

export class RuleActionContainerModel extends BaseContainerModel{
    bl_alg_cc_rule_action_hdr : bl_alg_cc_rule_action_hdr_RowInterface = new bl_alg_cc_rule_action_hdr_RowClass
    bl_alg_cc_rule_action_exts : bl_alg_cc_rule_action_ext_RowClass[] = []
}